import ApiService from './apiServices';
import {APIEndpoints} from './constants';

export const Api = {
  // Auth APIs
  login: async values => {
    const response = await ApiService.post(APIEndpoints.login, values);
    console.log('Login response:', response.data);
    return response;
  },

  register: async values => {
    const payload = {
      name: values?.name,
      email: values?.email,
      password: values?.password,
    };
    const response = await ApiService.post(APIEndpoints.register, payload);
    return response;
  },

  forgotPassword: async email => {
    return await ApiService.post(APIEndpoints.forgotPassword, email);
  },

  resetPassword: async (token, password) => {
    return await ApiService.post(APIEndpoints.resetPassword, {
      token,
      new_password: password,
    });
  },


  //profile APIs
  getProfile: async () => {
    return await ApiService.get(APIEndpoints.getProfile);
  },

  // Upload APIs
  getSubjects: async () => {
    return await ApiService.get(APIEndpoints.getSubjects);
  },

  uploadEssay: async (formData) => {
    return await ApiService.post(APIEndpoints.uploadEssay, formData);
  },

  // Get Submissions
  getSubmissions: async () => {
    return await ApiService.get(APIEndpoints.getSubmissions);
  },

  // Results APIs
  getResults: async () => {
    return await ApiService.get(APIEndpoints.getResults);
  },

  getResultDetails: async (id) => {
    return await ApiService.get(APIEndpoints.getResultDetails(id));
  },

  // past paper APIs
  getPastPapers: async () => {
    return await ApiService.get(APIEndpoints.getPastPapers);
  },

  // Payment APIs
  getPaymentHistory: async () => {
    return await ApiService.get(APIEndpoints.getPaymentHistory);
  },

  getActivePackage: async () => {
    return await ApiService.get(APIEndpoints.getActivePackage);
  },

  // Plans APIs
  getPlans: async (activeOnly = true) => {
    return await ApiService.get(APIEndpoints.getPlans, {
      params: { active_only: activeOnly }
    });
  },

  createCheckoutSession: async (price_id) => {
    return await ApiService.post(APIEndpoints.createCheckoutSession, {
      price_id: price_id
    });
  },

  getMySubscription: async () => {
    return await ApiService.get(APIEndpoints.getMySubscription);
  },

  getMyTransactions: async (limit = 20) => {
    return await ApiService.get(APIEndpoints.getMyTransactions, {
      params: { limit }
    });
  },

  getMyPurchases: async (includeExpired = true) => {
    return await ApiService.get(APIEndpoints.getMyPurchases, {
      params: { include_expired: includeExpired }
    });
  },


// 

};